<template>
	<div v-if="permission != null">
		<TopAppBar
			:leftBtnMode="leftBtnMode"
			:rightBtnMode="rightBtnMode"
			:title="brandName"
			:leftBtnMethod="leftBtnMethod"
			:rightBtnMethod="rightBtnMethod"
      :hideCategory="false"
			:staticMode="false"
		>
		</TopAppBar>
	<div class="d-flex h-full flex-column">
	<TopAppBarDrawer></TopAppBarDrawer>
		<main class="main-wrapper flex-grow-1 ">
			<!-- <div class="d-flex align-items-center bg-white">
				<div class="t-headline13 t-color-headlineBlack pda-14 t-center font-m flex-grow-1 ">
					<div class="font-m">{{title}}</div>
				</div>
			</div>
			<div class="divider"></div> -->
			<!-- subtabs -->

			<div class="container container--narrow pdt-50 pdb-50">
				<div class="border b-radius4 pda-36">
					<div class="t-headline10 font-b ">{{title}}</div>
					<div class="mgt-24 bg-shadow2 h-2"></div>
				<div class="t-body1 t-color-bodyGrayA font-r t-line-h-26">
					<iframe class="bg-white w-full b-none height-frame" :src="guidance"></iframe>
				</div>
				</div>


				<div class="mgt-50 mgb-50 ">
					<router-link tabindex="0" to="/licensePopulate" class="mdc-button mdc-button--raised bg-mainBtn t-color-mainBtnText mgr-8">
						<div class="mdc-button__ripple"></div>
						<span class="mdc-button__label t-body2 font-r">{{ $t('1313') }}</span>
					</router-link>
				</div>
			</div>
		</main>
		</div>
	</div>
</template>

<script>
// Components/Mixin/Extend/API define
import httpService from "@/api/httpService.js";
import licenseApi from "@/api/licenseApi.js";
import memberApi from "@/api/memberApi.js";
import TopAppBarDrawer from "../TopAppBarDrawer.vue";
import TopAppBar from '@/components/TopAppBar.vue'
import {topAppBarMixin} from '@/mixins/topAppBar.js'

export default {
	components: {
		TopAppBar,
		TopAppBarDrawer
	},

	data() {
		return {
			memberId: null,
			guidance: null,
			permission: null,
			brandName: localStorage.getItem('brandName')
		};
	},

	mixins: [topAppBarMixin],

	mounted() {
		// setting topAppbar
		this.setTopAppBarCloseOnly(this.$t('1311'));
		memberApi.getMemberInfo().then((response) => {
			this.memberId = response.data.data.id;
		}).then((response) => {
			let params = {
				"memberId": this.memberId
			};
			this.getResponsibility(params);
		}).catch((err) => {
			console.log(err);
		}).catch((err) => {
			console.log(err);
		});
	},
	methods: {
		gotoBack() {
			this.$router.go(-1);
		},

		getGuidance(params) {
			licenseApi.getEnrolmentGuidance(params)
			.then((response) => {
				//console.log(response.data.data)
				this.guidance = response.data.data.resourceUri;
			})
			.catch((err)=>{
				console.log(err);
			});
		},

		getResponsibility(params) {
			licenseApi.getLicenseResponsibility(params).then((response) => {
				// console.log("Responsibility Data");
				// console.log(response.data.data);
				if(response.data.data.type.translate == 'NONE'){
					this.$alert({
						title: "",
						content:this.$t("3094"),
						accept: this.$t("3095")
					})
					.then(() => {
						this.$router.push('/member/myinfo');
					})
					.catch(() => {});
				} else {
					let params = {
						"memberId" : this.memberId
					}
					this.getLicenseInfo(params);
				}
			}).then( (error) => {
				console.log(error);
			});
		},

		getLicenseInfo(params) {
			licenseApi.getMemberLicenseDetails(params).then((response)=>{
				// console.log(response, ' ___dkkd response');
				if(response.data.data == null){
					let args = {
					"memberId": this.memberId
					}
					this.permission = true;
					this.getGuidance(args);
				} else {
					this.$router.push('/viewLicense');
				}
			}).catch((err)=>{
				console.log(err);
			});
		}
	}
};
</script>

<style scoped>
	.height-frame{
		height: 755px;
		border: none;
	}
	.shadow {
		-webkit-box-shadow: 0 2px 2px 0 rgba(3, 3, 3, 0.14),
				0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
		box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14),
				0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
	}
	.bg-mainBtn {
	  background: var(--Mainbtn) !important;
  }
  .b-none{
	  border:none;
  }
</style>
